// @core/api/endpoints/task/list_status_definitions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListStatusDefinitionsResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List status definitions
 * Returns all custom status definitions for the tenant, optionally filtered by category.
 */
export async function ListStatusDefinitions(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListStatusDefinitionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/status-definitions`;
  const requestOptions = options;
  return client.get<ListStatusDefinitionsResponse>(requestPath, { ...requestOptions, params });
}
